/**
 * Loader — token-driven CSS spinner (brand-green arc on a hairline ring),
 * no animation library, zero extra chunk. Honors `prefers-reduced-motion`
 * via the stylesheet.
 *
 * Two modes:
 *   - default: full-screen splash for auth bootstrap and route transitions
 *     (fills its parent with a backdrop + an 80px spinner).
 *   - `inline`: a compact, centered spinner for in-content loading (dialog
 *     bodies, cards) — no full-bleed backdrop, so it doesn't blow out the
 *     surface it sits in.
 */
export interface LoaderProps {
  /** Compact in-content spinner instead of the full-screen splash. */
  inline?: boolean;
}

export function Loader({ inline = false }: LoaderProps) {
  if (inline) {
    return (
      <div className="loader-inline">
        <div
          className="betright-loader betright-loader-fallback betright-loader-sm"
          aria-hidden="true"
        />
      </div>
    );
  }

  return (
    <div className="loader-background">
      <div className="betright-loader betright-loader-fallback" aria-hidden="true" />
    </div>
  );
}

export default Loader;
